import React from 'react';

import {
  IconAD,
  IconAE,
  IconAF,
  IconAG,
  IconAI,
  IconAL,
  IconAM,
  IconAO,
  IconAR,
  IconAS,
  IconAT,
  IconAU,
  IconAW,
  IconAX,
  IconAZ,
  IconBA,
  IconBB,
  IconBD,
  IconBE,
  IconBF,
  IconBG,
  IconBH,
  IconBI,
  IconBJ,
  IconBL,
  IconBM,
  IconBN,
  IconBO,
  IconBQ,
  IconBR,
  IconBS,
  IconBT,
  IconBV,
  IconBW,
  IconBY,
  IconBZ,
  IconCA,
  IconCC,
  IconCD,
  IconCF,
  IconCG,
  IconCH,
  IconCI,
  IconCK,
  IconCL,
  IconCM,
  IconCN,
  IconCO,
  IconCR,
  IconCU,
  IconCV,
  IconCW,
  IconCX,
  IconCY,
  IconCZ,
  IconDE,
  IconDJ,
  IconDK,
  IconDM,
  IconDO,
  IconDZ,
  IconEC,
  IconEE,
  IconEG,
  IconEH,
  IconER,
  IconES,
  IconET,
  IconEU,
  IconFI,
  IconFJ,
  IconFK,
  IconFM,
  IconFO,
  IconFR,
  IconGA,
  IconGB,
  IconGD,
  IconGE,
  IconGF,
  IconGG,
  IconGH,
  IconGI,
  IconGL,
  IconGM,
  IconGN,
  IconGP,
  IconGQ,
  IconGR,
  IconGS,
  IconGT,
  IconGU,
  IconGW,
  IconGY,
  IconHK,
  IconHM,
  IconHN,
  IconHR,
  IconHT,
  IconHU,
  IconID,
  IconIE,
  IconIL,
  IconIM,
  IconIN,
  IconIO,
  IconIQ,
  IconIR,
  IconIS,
  IconIT,
  IconJE,
  IconJM,
  IconJO,
  IconJP,
  IconKE,
  IconKG,
  IconKH,
  IconKI,
  IconKM,
  IconKN,
  IconKP,
  IconKR,
  IconKW,
  IconKY,
  IconKZ,
  IconLA,
  IconLB,
  IconLC,
  IconLI,
  IconLK,
  IconLR,
  IconLS,
  IconLT,
  IconLU,
  IconLV,
  IconLY,
  IconMA,
  IconMC,
  IconMD,
  IconME,
  IconMF,
  IconMG,
  IconMH,
  IconMK,
  IconML,
  IconMM,
  IconMN,
  IconMO,
  IconMP,
  IconMQ,
  IconMR,
  IconMS,
  IconMT,
  IconMU,
  IconMV,
  IconMW,
  IconMX,
  IconMY,
  IconMZ,
  IconNA,
  IconNC,
  IconNE,
  IconNF,
  IconNG,
  IconNI,
  IconNL,
  IconNO,
  IconNP,
  IconNR,
  IconNU,
  IconNZ,
  IconOM,
  IconPA,
  IconPE,
  IconPF,
  IconPG,
  IconPH,
  IconPK,
  IconPL,
  IconPM,
  IconPN,
  IconPR,
  IconPS,
  IconPT,
  IconPW,
  IconPY,
  IconQA,
  IconRE,
  IconRO,
  IconRS,
  IconRU,
  IconRW,
  IconSA,
  IconSB,
  IconSC,
  IconSD,
  IconSE,
  IconSG,
  IconSH,
  IconSI,
  IconSJ,
  IconSK,
  IconSL,
  IconSM,
  IconSN,
  IconSO,
  IconSR,
  IconSS,
  IconST,
  IconSV,
  IconSX,
  IconSY,
  IconSZ,
  IconTC,
  IconTD,
  IconTF,
  IconTG,
  IconTH,
  IconTJ,
  IconTK,
  IconTL,
  IconTM,
  IconTN,
  IconTO,
  IconTR,
  IconTT,
  IconTV,
  IconTW,
  IconTZ,
  IconUA,
  IconUG,
  IconUM,
  IconUN,
  IconUS,
  IconUY,
  IconUZ,
  IconVA,
  IconVC,
  IconVE,
  IconVG,
  IconVI,
  IconVN,
  IconVU,
  IconWF,
  IconWS,
  IconYE,
  IconYT,
  IconZA,
  IconZM,
  IconZW
} from './countries';
import { IconFCList } from './types';

export const iconComponents = {
  AD: <IconAD />,
  AE: <IconAE />,
  AF: <IconAF />,
  AG: <IconAG />,
  AI: <IconAI />,
  AL: <IconAL />,
  AM: <IconAM />,
  AO: <IconAO />,
  AR: <IconAR />,
  AS: <IconAS />,
  AT: <IconAT />,
  AU: <IconAU />,
  AW: <IconAW />,
  AX: <IconAX />,
  AZ: <IconAZ />,
  BA: <IconBA />,
  BB: <IconBB />,
  BD: <IconBD />,
  BE: <IconBE />,
  BF: <IconBF />,
  BG: <IconBG />,
  BH: <IconBH />,
  BI: <IconBI />,
  BJ: <IconBJ />,
  BL: <IconBL />,
  BM: <IconBM />,
  BN: <IconBN />,
  BO: <IconBO />,
  BQ: <IconBQ />,
  BR: <IconBR />,
  BS: <IconBS />,
  BT: <IconBT />,
  BV: <IconBV />,
  BW: <IconBW />,
  BY: <IconBY />,
  BZ: <IconBZ />,
  CA: <IconCA />,
  CC: <IconCC />,
  CD: <IconCD />,
  CF: <IconCF />,
  CG: <IconCG />,
  CH: <IconCH />,
  CI: <IconCI />,
  CK: <IconCK />,
  CL: <IconCL />,
  CM: <IconCM />,
  CN: <IconCN />,
  CO: <IconCO />,
  CR: <IconCR />,
  CU: <IconCU />,
  CV: <IconCV />,
  CW: <IconCW />,
  CX: <IconCX />,
  CY: <IconCY />,
  CZ: <IconCZ />,
  DE: <IconDE />,
  DJ: <IconDJ />,
  DK: <IconDK />,
  DM: <IconDM />,
  DO: <IconDO />,
  DZ: <IconDZ />,
  EC: <IconEC />,
  EE: <IconEE />,
  EG: <IconEG />,
  EH: <IconEH />,
  ER: <IconER />,
  ES: <IconES />,
  ET: <IconET />,
  EU: <IconEU />,
  FI: <IconFI />,
  FJ: <IconFJ />,
  FK: <IconFK />,
  FM: <IconFM />,
  FO: <IconFO />,
  FR: <IconFR />,
  GA: <IconGA />,
  GB: <IconGB />,
  GD: <IconGD />,
  GE: <IconGE />,
  GF: <IconGF />,
  GG: <IconGG />,
  GH: <IconGH />,
  GI: <IconGI />,
  GL: <IconGL />,
  GM: <IconGM />,
  GN: <IconGN />,
  GP: <IconGP />,
  GQ: <IconGQ />,
  GR: <IconGR />,
  GS: <IconGS />,
  GT: <IconGT />,
  GU: <IconGU />,
  GW: <IconGW />,
  GY: <IconGY />,
  HK: <IconHK />,
  HM: <IconHM />,
  HN: <IconHN />,
  HR: <IconHR />,
  HT: <IconHT />,
  HU: <IconHU />,
  ID: <IconID />,
  IE: <IconIE />,
  IL: <IconIL />,
  IM: <IconIM />,
  IN: <IconIN />,
  IO: <IconIO />,
  IQ: <IconIQ />,
  IR: <IconIR />,
  IS: <IconIS />,
  IT: <IconIT />,
  JE: <IconJE />,
  JM: <IconJM />,
  JO: <IconJO />,
  JP: <IconJP />,
  KE: <IconKE />,
  KG: <IconKG />,
  KH: <IconKH />,
  KI: <IconKI />,
  KM: <IconKM />,
  KN: <IconKN />,
  KP: <IconKP />,
  KR: <IconKR />,
  KW: <IconKW />,
  KY: <IconKY />,
  KZ: <IconKZ />,
  LA: <IconLA />,
  LB: <IconLB />,
  LC: <IconLC />,
  LI: <IconLI />,
  LK: <IconLK />,
  LR: <IconLR />,
  LS: <IconLS />,
  LT: <IconLT />,
  LU: <IconLU />,
  LV: <IconLV />,
  LY: <IconLY />,
  MA: <IconMA />,
  MC: <IconMC />,
  MD: <IconMD />,
  ME: <IconME />,
  MF: <IconMF />,
  MG: <IconMG />,
  MH: <IconMH />,
  MK: <IconMK />,
  ML: <IconML />,
  MM: <IconMM />,
  MN: <IconMN />,
  MO: <IconMO />,
  MP: <IconMP />,
  MQ: <IconMQ />,
  MR: <IconMR />,
  MS: <IconMS />,
  MT: <IconMT />,
  MU: <IconMU />,
  MV: <IconMV />,
  MW: <IconMW />,
  MX: <IconMX />,
  MY: <IconMY />,
  MZ: <IconMZ />,
  NA: <IconNA />,
  NC: <IconNC />,
  NE: <IconNE />,
  NF: <IconNF />,
  NG: <IconNG />,
  NI: <IconNI />,
  NL: <IconNL />,
  NO: <IconNO />,
  NP: <IconNP />,
  NR: <IconNR />,
  NU: <IconNU />,
  NZ: <IconNZ />,
  OM: <IconOM />,
  PA: <IconPA />,
  PE: <IconPE />,
  PF: <IconPF />,
  PG: <IconPG />,
  PH: <IconPH />,
  PK: <IconPK />,
  PL: <IconPL />,
  PM: <IconPM />,
  PN: <IconPN />,
  PR: <IconPR />,
  PS: <IconPS />,
  PT: <IconPT />,
  PW: <IconPW />,
  PY: <IconPY />,
  QA: <IconQA />,
  RE: <IconRE />,
  RO: <IconRO />,
  RS: <IconRS />,
  RU: <IconRU />,
  RW: <IconRW />,
  SA: <IconSA />,
  SB: <IconSB />,
  SC: <IconSC />,
  SD: <IconSD />,
  SE: <IconSE />,
  SG: <IconSG />,
  SH: <IconSH />,
  SI: <IconSI />,
  SJ: <IconSJ />,
  SK: <IconSK />,
  SL: <IconSL />,
  SM: <IconSM />,
  SN: <IconSN />,
  SO: <IconSO />,
  SR: <IconSR />,
  SS: <IconSS />,
  ST: <IconST />,
  SV: <IconSV />,
  SX: <IconSX />,
  SY: <IconSY />,
  SZ: <IconSZ />,
  TC: <IconTC />,
  TD: <IconTD />,
  TF: <IconTF />,
  TG: <IconTG />,
  TH: <IconTH />,
  TJ: <IconTJ />,
  TK: <IconTK />,
  TL: <IconTL />,
  TM: <IconTM />,
  TN: <IconTN />,
  TO: <IconTO />,
  TR: <IconTR />,
  TT: <IconTT />,
  TV: <IconTV />,
  TW: <IconTW />,
  TZ: <IconTZ />,
  UA: <IconUA />,
  UG: <IconUG />,
  UM: <IconUM />,
  UN: <IconUN />,
  US: <IconUS />,
  UY: <IconUY />,
  UZ: <IconUZ />,
  VA: <IconVA />,
  VC: <IconVC />,
  VE: <IconVE />,
  VG: <IconVG />,
  VI: <IconVI />,
  VN: <IconVN />,
  VU: <IconVU />,
  WF: <IconWF />,
  WS: <IconWS />,
  YE: <IconYE />,
  YT: <IconYT />,
  ZA: <IconZA />,
  ZM: <IconZM />,
  ZW: <IconZW />
};

export const iconFC: IconFCList = {
  AD: IconAD,
  AE: IconAE,
  AF: IconAF,
  AG: IconAG,
  AI: IconAI,
  AL: IconAL,
  AM: IconAM,
  AO: IconAO,
  AR: IconAR,
  AS: IconAS,
  AT: IconAT,
  AU: IconAU,
  AW: IconAW,
  AX: IconAX,
  AZ: IconAZ,
  BA: IconBA,
  BB: IconBB,
  BD: IconBD,
  BE: IconBE,
  BF: IconBF,
  BG: IconBG,
  BH: IconBH,
  BI: IconBI,
  BJ: IconBJ,
  BL: IconBL,
  BM: IconBM,
  BN: IconBN,
  BO: IconBO,
  BQ: IconBQ,
  BR: IconBR,
  BS: IconBS,
  BT: IconBT,
  BV: IconBV,
  BW: IconBW,
  BY: IconBY,
  BZ: IconBZ,
  CA: IconCA,
  CC: IconCC,
  CD: IconCD,
  CF: IconCF,
  CG: IconCG,
  CH: IconCH,
  CI: IconCI,
  CK: IconCK,
  CL: IconCL,
  CM: IconCM,
  CN: IconCN,
  CO: IconCO,
  CR: IconCR,
  CU: IconCU,
  CV: IconCV,
  CW: IconCW,
  CX: IconCX,
  CY: IconCY,
  CZ: IconCZ,
  DE: IconDE,
  DJ: IconDJ,
  DK: IconDK,
  DM: IconDM,
  DO: IconDO,
  DZ: IconDZ,
  EC: IconEC,
  EE: IconEE,
  EG: IconEG,
  EH: IconEH,
  ER: IconER,
  ES: IconES,
  ET: IconET,
  EU: IconEU,
  FI: IconFI,
  FJ: IconFJ,
  FK: IconFK,
  FM: IconFM,
  FO: IconFO,
  FR: IconFR,
  GA: IconGA,
  GB: IconGB,
  GD: IconGD,
  GE: IconGE,
  GF: IconGF,
  GG: IconGG,
  GH: IconGH,
  GI: IconGI,
  GL: IconGL,
  GM: IconGM,
  GN: IconGN,
  GP: IconGP,
  GQ: IconGQ,
  GR: IconGR,
  GS: IconGS,
  GT: IconGT,
  GU: IconGU,
  GW: IconGW,
  GY: IconGY,
  HK: IconHK,
  HM: IconHM,
  HN: IconHN,
  HR: IconHR,
  HT: IconHT,
  HU: IconHU,
  ID: IconID,
  IE: IconIE,
  IL: IconIL,
  IM: IconIM,
  IN: IconIN,
  IO: IconIO,
  IQ: IconIQ,
  IR: IconIR,
  IS: IconIS,
  IT: IconIT,
  JE: IconJE,
  JM: IconJM,
  JO: IconJO,
  JP: IconJP,
  KE: IconKE,
  KG: IconKG,
  KH: IconKH,
  KI: IconKI,
  KM: IconKM,
  KN: IconKN,
  KP: IconKP,
  KR: IconKR,
  KW: IconKW,
  KY: IconKY,
  KZ: IconKZ,
  LA: IconLA,
  LB: IconLB,
  LC: IconLC,
  LI: IconLI,
  LK: IconLK,
  LR: IconLR,
  LS: IconLS,
  LT: IconLT,
  LU: IconLU,
  LV: IconLV,
  LY: IconLY,
  MA: IconMA,
  MC: IconMC,
  MD: IconMD,
  ME: IconME,
  MF: IconMF,
  MG: IconMG,
  MH: IconMH,
  MK: IconMK,
  ML: IconML,
  MM: IconMM,
  MN: IconMN,
  MO: IconMO,
  MP: IconMP,
  MQ: IconMQ,
  MR: IconMR,
  MS: IconMS,
  MT: IconMT,
  MU: IconMU,
  MV: IconMV,
  MW: IconMW,
  MX: IconMX,
  MY: IconMY,
  MZ: IconMZ,
  NA: IconNA,
  NC: IconNC,
  NE: IconNE,
  NF: IconNF,
  NG: IconNG,
  NI: IconNI,
  NL: IconNL,
  NO: IconNO,
  NP: IconNP,
  NR: IconNR,
  NU: IconNU,
  NZ: IconNZ,
  OM: IconOM,
  PA: IconPA,
  PE: IconPE,
  PF: IconPF,
  PG: IconPG,
  PH: IconPH,
  PK: IconPK,
  PL: IconPL,
  PM: IconPM,
  PN: IconPN,
  PR: IconPR,
  PS: IconPS,
  PT: IconPT,
  PW: IconPW,
  PY: IconPY,
  QA: IconQA,
  RE: IconRE,
  RO: IconRO,
  RS: IconRS,
  RU: IconRU,
  RW: IconRW,
  SA: IconSA,
  SB: IconSB,
  SC: IconSC,
  SD: IconSD,
  SE: IconSE,
  SG: IconSG,
  SH: IconSH,
  SI: IconSI,
  SJ: IconSJ,
  SK: IconSK,
  SL: IconSL,
  SM: IconSM,
  SN: IconSN,
  SO: IconSO,
  SR: IconSR,
  SS: IconSS,
  ST: IconST,
  SV: IconSV,
  SX: IconSX,
  SY: IconSY,
  SZ: IconSZ,
  TC: IconTC,
  TD: IconTD,
  TF: IconTF,
  TG: IconTG,
  TH: IconTH,
  TJ: IconTJ,
  TK: IconTK,
  TL: IconTL,
  TM: IconTM,
  TN: IconTN,
  TO: IconTO,
  TR: IconTR,
  TT: IconTT,
  TV: IconTV,
  TW: IconTW,
  TZ: IconTZ,
  UA: IconUA,
  UG: IconUG,
  UM: IconUM,
  UN: IconUN,
  US: IconUS,
  UY: IconUY,
  UZ: IconUZ,
  VA: IconVA,
  VC: IconVC,
  VE: IconVE,
  VG: IconVG,
  VI: IconVI,
  VN: IconVN,
  VU: IconVU,
  WF: IconWF,
  WS: IconWS,
  YE: IconYE,
  YT: IconYT,
  ZA: IconZA,
  ZM: IconZM,
  ZW: IconZW
};

export const iconSize = {
  sm: {
    width: 16,
    height: 16
  },
  md: {
    width: 24,
    height: 24
  },
  lg: {
    width: 36,
    height: 36
  },
  xl: {
    width: 48,
    height: 48
  },
  flag: {
    width: 24,
    height: 18
  }
};

export const iconsList = Object.keys(iconComponents);

export const iconSettings = {
  width: 24,
  height: 24
};

export const flagStyles = {
  backgroundImage: `url("https://cdn.xsolla.net/flags.jpeg")`,
  backgroundRepeat: 'no-repeat',
  backgroundSize: '5928px 18px',
  width: '24px',
  height: '18px'
};
